import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  position: absolute;
  z-index: 100;
  left: ${props => props.left};
  right: ${props => props.right};
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  width: ${props => props.width};
  height: ${props => props.height};
`;
